/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { EbsRestoreDestination } from '../models/EbsRestoreDestination';

export class RestoreVolumeToEbsRequest {
  /**
  * Cloud-provider-assigned ID of the volume to restore.
  */
  'providerVolumeId': string;
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': EbsRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "providerVolumeId",
      "baseName": "providerVolumeId",
      "type": "string",
      "format": ""
    },
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "EbsRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreVolumeToEbsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

